<div [innerHtml]="rawSvgElementHtml" [ngClass]="containerClass">
  <ng-content></ng-content>
</div>
